import { h, ComponentChildren } from "preact";

import Button from "../Button";
import IconDelete from "../Icons/IconDelete";

import classname from "../../foundation/utils/classname";
import { stopPropagation } from "../../foundation/utils/legacy";

import "./style.css";

interface Props {
    class?: string;
    children: ComponentChildren;
    type: "default" | "warning" | "info";
    emoji?: string;
    actionContent?: ComponentChildren;
    onHideClick?: (ev: MouseEvent) => void;
    onActionClick?: (ev: MouseEvent) => void;
    hideButtonText?: string;
    hideEmoji?: boolean;
}

function HintBox({
    class: cssClass,
    children,
    type,
    emoji,
    actionContent,
    onHideClick,
    onActionClick,
    hideButtonText,
    hideEmoji
}: Props) {
    const footer = [];
    const defaultEmoji = type === "warning" ? "⚠️" : "💁‍♀️";

    if (actionContent && typeof actionContent === "string") {
        footer.push(
            <Button class="hintAction" onClick={onActionClick} onMouseDown={stopPropagation}>{actionContent}</Button>
        );
    } else if (actionContent) {
        footer.push(actionContent);
    }

    if (onHideClick) {
        footer.push(
            <Button class="hideHintButton" onClick={onHideClick} onMouseDown={stopPropagation}>
                <IconDelete transparent/>
                {hideButtonText}
            </Button>
        );
    }

    return (
        <div class={classname("hintBox", cssClass, type)}>
            {!hideEmoji && <span class="emoji">{emoji || defaultEmoji}</span>}
            <div class="hintContent">
                {children}
                {footer.length > 0 && (
                    <div class="hintFooter">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
}

HintBox.defaultProps = {
    hideButtonText: "Got it!",
    type: "default"
};

export default HintBox;
